import { getFeatureToggleClient } from 'infra/featureToggles'

export default function isMultiFactorAuthBypassFixEnabled(): boolean {
  return getFeatureToggleClient().variation(
    'WorkPortal.MultiFactorAuthBypassFix',
    false,
  )
}
